module.exports = __webpack_public_path__ + "f4886e55e2ab74979a3bf74925cf88c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2023_chart.png
// module id = 1719
// module chunks = 0